import moment from 'moment';
import { IWalletTransactionFilters } from 'src/view/screens/WalletTransactionLogScreen/screens/WTLogScreen/types/walletTransaction';

export enum WALLETS_TRANSACTIONS_COLUMN {
  DEPOSIT_DATE = 'deposit_date',
  AUTHOR = 'author_name',
  OBJECT = 'object_phone',
  TRANSACTION_AMOUNT = 'transaction_amount',
  BALANCE_TYPE = 'balance_type',
  TRANSACTION_TYPE = 'transaction_type',
  REASON = 'reason',
  ORDER_NUMBER = 'order_number',
  EXPIRATION_DATE = 'expiration_date',
  WALLET_ID = 'wallet_id',
}

export enum BALANCE_TYPE {
  COMPENSATION = 1, // Top Up
  REFUND = 2,
  CASHBACK = 3,
}

export const BALANCE_TYPE_TXT = {
  [BALANCE_TYPE.COMPENSATION]: 'balance_type_topup', // Top Up
  [BALANCE_TYPE.REFUND]: 'balance_type_refund',
  [BALANCE_TYPE.CASHBACK]: 'balance_type_cashback',
};

export const balanceTypeFilterOptions = [
  { label: BALANCE_TYPE_TXT[BALANCE_TYPE.COMPENSATION], value: BALANCE_TYPE.COMPENSATION },
  { label: BALANCE_TYPE_TXT[BALANCE_TYPE.REFUND], value: BALANCE_TYPE.REFUND },
  { label: BALANCE_TYPE_TXT[BALANCE_TYPE.CASHBACK], value: BALANCE_TYPE.CASHBACK },
];

export enum TRANSACTION_TYPE {
  COMPENSATION = 1, // Deposit
  REFUND = 2,
  EXPIRATION = 3,
  WITHDRAW = 4, // Redeem
  CASHBACK = 6,
  CORRECTED = 7,
}

export const TRANSACTION_TYPE_TXT = {
  [TRANSACTION_TYPE.COMPENSATION]: 'wallet_event_deposit', // Deposit
  [TRANSACTION_TYPE.REFUND]: 'wallet_event_refund',
  [TRANSACTION_TYPE.EXPIRATION]: 'wallet_event_expiration',
  [TRANSACTION_TYPE.WITHDRAW]: 'wallet_event_redeem', // Redeem
  [TRANSACTION_TYPE.CASHBACK]: 'wallet_event_cashback',
  [TRANSACTION_TYPE.CORRECTED]: 'wallet_event_corrected',
};

export const transactionTypeFilterOptions = [
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.COMPENSATION], value: TRANSACTION_TYPE.COMPENSATION },
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.REFUND], value: TRANSACTION_TYPE.REFUND },
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.EXPIRATION], value: TRANSACTION_TYPE.EXPIRATION },
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.WITHDRAW], value: TRANSACTION_TYPE.WITHDRAW },
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.CASHBACK], value: TRANSACTION_TYPE.CASHBACK },
  { label: TRANSACTION_TYPE_TXT[TRANSACTION_TYPE.CORRECTED], value: TRANSACTION_TYPE.CORRECTED },
];

export const defaultWalletTransactionFilters: IWalletTransactionFilters = {
  userId: undefined,
  sortBy: undefined,
  sortDir: undefined,
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
  balance_type: undefined,
  transaction_type: undefined,
};
